/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import QueryBuilder from 'ComponentsV2/CommonComponents/QueryBuilder';

import './queryBuilder.scss';

const VenueQueryBuilder = (props) => {
    const { value, fields, projectId, withoutOrConjunction, onChange } = props;

    return (
        <QueryBuilder
            value={value}
            fields={fields}
            projectId={projectId}
            withoutOrConjunction={withoutOrConjunction}
            onChange={onChange}
            className="tw-w-full"
        />
    );
};

VenueQueryBuilder.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.object,
    fields: PropTypes.object,
    projectId: PropTypes.string,
    withoutOrConjunction: PropTypes.bool,
};

VenueQueryBuilder.defaultProps = {
    withoutOrConjunction: false,
};

export default VenueQueryBuilder;
